import HeroHome from "../../components/HeroHome/HeroHome";
import ProductDetails from "../../components/ProductDetails/ProductDetails";

const Home = () => {
    return (
        <main>
            <HeroHome />
            <ProductDetails />
        </main>
    );
};

export default Home;
